import Strategy from "app/types/Strategy";
// Actions
import MixpanelActions from "app/features/mixpanel/MixpanelActions";
// Strategies
import {
  handleEpisodeSuggestedAuthorClickStrategy
} from "app/features/mixpanel/MixpanelStrategies/Episode.strategies";

const EpisodeStategyMap:Record<string, Strategy> = {
  [MixpanelActions.handleEpisodeSuggestedAuthorClick.type]: handleEpisodeSuggestedAuthorClickStrategy,
};

export default EpisodeStategyMap;